// extracted by mini-css-extract-plugin
export default {"input":"styles_input__zgxG+","inputWithDescription":"styles_inputWithDescription__j8vhL"};